import {

    FETCH_START,
    FETCH_END,
    CONTRACT_TYPE_CONFIGURATION_SUCCESS,
} from '../../../actions/DesignerStudio/ContractTypeConfiguration/ActionTypes'

const initialState = {
    loading: false,
    contractTypeConfigurationData: [],
};

const ContractTypeConfigurationReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_START:
            return {
                ...state,
                loading: true,
            };
        case FETCH_END:
            return {
                ...state,
                loading: false,
            };
        case CONTRACT_TYPE_CONFIGURATION_SUCCESS:
            return {
                ...state,
                contractTypeConfigurationData: action.data
            }
        default:
            return state;
    }
};

export default ContractTypeConfigurationReducer;
